// Dependencies
import React, { FC, ReactElement, useEffect, useState } from 'react';
// Core & Lab
import Grid from '@mui/material/Grid';
import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';
import { Extra } from './objects/Extra';
import ManualAccommodationExtraCard from './manualAccommodationExtraCard';
import { useTranslation } from 'react-i18next';
import { deleteExtraListDefinition, getExtrasListDefinition } from './services/extraServices';
import { useSelector } from 'react-redux';
import { AppState } from '../../reducers';
// Components

const ManualAccommodationExtra: FC = (): ReactElement => {
    const { t } = useTranslation();
    const client_id = useSelector((state: AppState) => state.header.client_id);
    const [extraList, setExtraList] = useState<Extra[]>([]);
    const [editExtra, setEditExtra] = useState<null | number>(null);
    const removeFromList = (extra: Extra) => {
        deleteExtraListDefinition(client_id, { label: extra.label, reference: extra.reference, id: extra.id }).then((response) => {
            setExtraList((state) => state.filter((item: Extra) => item.reference !== extra.reference));
        });
    };
    const addExtra = () => {
        setExtraList((state) => [...state, { label: '', reference: '' }]);
        setEditExtra(extraList.length);
    };
    const cancelExtra = () => {
        if (extraList.length > 0) {
            setExtraList((state) => state.slice(0, -1));
        }
    };
    useEffect(() => {
        if (client_id !== null) {
            getExtrasListDefinition(client_id).then((response) => {
                setExtraList(response.data.results);
            });
        }
    }, []);
    return (
        <Stack direction={'column'} spacing={ 2 }>
            <Typography variant={'h6'}>{t('shared.extra-handle')}</Typography>
            <Alert severity={'info'} sx={{ m: 8, width: '100%' }}>
                <AlertTitle>{t('shared.info')} :</AlertTitle>
                {t('shared.extra-handle-info')}
            </Alert>
            <Grid container spacing={2} alignItems={'flex-start'} sx={{ m: 8, position: 'relative', marginBottom: 10 }}>
                <Grid item xs={ 5 } container direction={'column'} sx={{ border: '1px solid #707070', padding: 1, borderRadius: '40px', marginBottom: 10, pr: '16px !important', pb: '16px !important' }}>
                    {
                        extraList.map((extra: Extra, index: number) => (
                            <ManualAccommodationExtraCard
                                extra={extra}
                                key={index}
                                removeFromList={removeFromList}
                                editExtra={editExtra}
                                setEditExtra={setEditExtra}
                                index={index}
                                setExtraList={setExtraList}
                                cancelExtra={cancelExtra}
                                extraList={extraList}
                            />
                        ))
                    }
                    <Grid item sx={{ padding: 1, margin: 1, textAlign: 'center' }}>
                        <Button size='small' variant={'contained'} fullWidth onClick={addExtra}>
                            Créer un nouvel extra
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Stack>
    );
};

export default ManualAccommodationExtra;